const Throbber = ({title}) => {
    return (
        <div className="throbber">
            {title ? title : 'Laden...'}
        </div>
    )
};

export default Throbber;
